import { createContext } from "react";

import { createEventHub } from "@bokio/shared/services/api/signalRHub";

import type * as m from "@bokio/mobile-web-shared/core/model/model";

export interface BookkeepingCheckActivityMessage {
	CheckId: string;
	Status: m.Entities.Accounting.Reconciliations.BookkeepingCheckStatus;
	CompanyId: string;
	VerificationId: string | null;
}

export interface BookkeepingCheckActivityState {
	counter: number;
	lastCheckId: string | undefined;
	lastStatus: m.Entities.Accounting.Reconciliations.BookkeepingCheckStatus | undefined;
	lastVerificationId: string | undefined;
}

export const defaultContextValue: BookkeepingCheckActivityState = {
	counter: 0,
	lastCheckId: undefined,
	lastStatus: undefined,
	lastVerificationId: undefined,
};

export const BookkeepingCheckActivityContext = createContext(defaultContextValue);

export const bookkeepingCheckActivityHub = createEventHub<BookkeepingCheckActivityMessage>();
